export default __webpack_public_path__ + "static/media/techwarno.f5712c9b.png";